export default __webpack_public_path__ + "static/media/service-provider.5965e854.png";